module.exports = __webpack_public_path__ + "static/media/FAVORITOS_B.ea9386ad.svg";